import { render } from "./PublishArticle.vue?vue&type=template&id=a579a34c&scoped=true"
import script from "./PublishArticle.vue?vue&type=script&lang=js"
export * from "./PublishArticle.vue?vue&type=script&lang=js"

import "./PublishArticle.vue?vue&type=style&index=0&id=a579a34c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a579a34c"]])

export default __exports__